export default __webpack_public_path__ + "static/media/login-logo.0b1cc6e6.svg";